import * as actionTypes from '../actions/types';

const initialState = {
    estaVisible: false,
    titulo: '',
    contenido: null,
    mensaje: '',
    clickAceptar: null,
    clickCancelar: null,
    deshabilitarAceptar: false,
    textoBtnAceptar: 'Aceptar',
    esAlerta: false,
    maxWidth: '600px',
    whiteSpace: 'unset',
};

export function ventanaDialogoReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA:
            return {
                ...initialState,
                ...action.payload,
            };

        default:
            return state;
    }
}
